export default __webpack_public_path__ + "static/media/q1.d2f572f2.svg";